export const mrpwProductVersions = [
  /**
   * The very first restaurant product, corresponding to the legacy policy "restaurants-2022-05-13", mapped to mrpw-rest-v1
   */
  '1.1',
  /**
   * Minor iteration first restaurant product, corresponding to the legacy policy "restaurants-v2", mapped to mrpw-rest-v1
   */
  '1.2',
  /**
   * The restaurant product as a part of the multi-product policy, with many upgrades, mapped to mrpw-rest-v2
   */
  '2',
  /**
   * The new restaurant product, as new policy with new pricing/taxes updates, mapped to mrpw-rest-v3
   */
  '3',
  /**
   * Same product as v3 (no changes to coverage/pricing). This just a minor bump introduced
   * for Project Churn's [Measure 5](https://app.notion.com/p/orus-team/Tech-Scoping-ac90ab24de318301be6701911fcc734b?source=copy_link#f701560538b342b98ab534128adbbb70)
   * so the annual-payment requirement applies only from this version onwards,
   * protecting already-signed v3 subscriptions.
   */
  '3.1',
  /** SEPA-only payment-method restriction
   */
  '3.2',
] as const
export type MrpwVersion = (typeof mrpwProductVersions)[number]
